import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TitleNode } from 'src/app/dto';

@Component({
    selector: 'app-title-node',
    templateUrl: './title-node.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TitleNodeComponent {
    @Input() node: TitleNode;
}
